export const ACCESS_KEY_API_PATH = 'accessKey';

export const ACCESS_KEYS_METADATA_REQUESTED = 'accessKeys/METADATA_REQUESTED';
export const ACCESS_KEYS_METADATA_SUCCESS = 'accessKeys/METADATA_SUCCESS';
export const ACCESS_KEYS_METADATA_FAILURE = 'accessKeys/METADATA_FAILURE';

export const ACCESS_KEYS_LIST_DATA_REQUESTED = 'accessKeys/LIST_REQUESTED';
export const ACCESS_KEYS_LIST_DATA_SUCCESS = 'accessKeys/LIST_SUCCESS';
export const ACCESS_KEYS_LIST_DATA_FAILURE = 'accessKeys/LIST_FAILURE';

export const ACCESS_KEYS_CREATE_REQUESTED = 'accessKeys/CREATE_REQUESTED';
export const ACCESS_KEYS_CREATE_SUCCESS = 'accessKeys/CREATE_SUCCESS';
export const ACCESS_KEYS_CREATE_FAILURE = 'accessKeys/CREATE_FAILURE';

export const ACCESS_KEYS_DELETE_REQUESTED = 'accessKeys/DELETE_REQUESTED';
export const ACCESS_KEYS_DELETE_SUCCESS = 'accessKeys/DELETE_SUCCESS';
export const ACCESS_KEYS_DELETE_FAILURE = 'accessKeys/DELETE_FAILURE';

export const ACCESS_KEYS_MESSAGE_CLEAR = 'accessKeys/MESSAGE_CLEAR';

export const ACCESS_KEYS_DISABLE_CONFIRMATION_SHOW = 'accessKeys/DISABLE_CONFIRMATION_SHOW';
export const ACCESS_KEYS_DISABLE_CONFIRMATION_HIDE = 'accessKeys/DISABLE_CONFIRMATION_HIDE';
